import React from "react";
import type { MacroComponentParams } from "@enonic/react-components";

const EmbedMacro = ({ data }: MacroComponentParams) => {
  const { content } = (data as { content?: string }) ?? {};
  if (!content) return null;

  return <div className="embed-macro" dangerouslySetInnerHTML={{ __html: content }} />;
};

export default EmbedMacro;
